const SOCIAL_MEDIA_LINKS = {
  instagram: 'https://www.instagram.com/goodingandcompany/',
  facebook: 'https://www.facebook.com/GoodingChristies',
  twitter: 'https://twitter.com/goodingandco',
  youtube: 'https://www.youtube.com/@GoodingChristies',
  website: 'https://www.goodingco.com/',
};

export { SOCIAL_MEDIA_LINKS };
